import React from "react";
import Select, {
  MultiValue,
  StylesConfig,
  ControlProps,
  CSSObjectWithLabel,
} from "react-select";

// 👇 Define the option type
export type OptionType = {
  value: string;
  label: string;
  // Optional: if you use countries and business_units in options
  countries?: any[];
  business_units?: any[];
};

interface Props {
  label: string;
  options: OptionType[];
  value: OptionType[];
  onChange: (value: OptionType[]) => void;
  disabled?: boolean;
}

const MultiFilter: React.FC<Props> = ({
  label,
  options,
  value,
  onChange,
  disabled,
}) => {
  return (
    <div className="min-w-[200px] mb-4">
      <label className="block text-sm font-semibold text-gray-600 mb-1">
        {label}
      </label>
      <Select
        options={options}
        isMulti
        value={value}
        onChange={(selected: MultiValue<OptionType>) =>
          onChange(selected as OptionType[])
        }
        isDisabled={disabled}
        className="text-sm"
        classNamePrefix="react-select"
        styles={{
          control: (
            base: CSSObjectWithLabel,
            props: ControlProps<OptionType, true>
          ): CSSObjectWithLabel => ({
            ...base,
            minHeight: "38px",
            borderColor: props.isFocused ? "#2563eb" : base.borderColor,
            boxShadow: props.isFocused ? "0 0 0 1px #2563eb" : base.boxShadow,
            "&:hover": {
              borderColor: "#2563eb",
            },
          }),
        }}
      />
    </div>
  );
};

export default MultiFilter;